<template>
  <Transition name="slide-up">
    <snap-alert v-if="isActive" :type="alertType" :border="true" class="flex justify-center fixed w-full top-[150px] lg:left-[5%] lg:right-[5%] z-[999999]">
      <snap-alert-title>
        <span class="text-gray-800">{{ alertTitle }}</span>
      </snap-alert-title>
      <snap-alert-description class="xs:w-fit sm:w-72 md:w-fit md:max-w-md">
        <span class="text-gray-500">{{ alertMessage }}</span>
      </snap-alert-description>
      <snap-alert-action v-if="isDismissable" slot="start">
        <snap-link text="Dismiss" sr-only="srOnly" target="_self" size="sm" :variant="alertType" @click="setAlertVisibility(false)"> </snap-link>
      </snap-alert-action>
    </snap-alert>
  </Transition>
</template>
<script lang="ts" setup>
import { ref } from "vue";
import { IAlertMessage } from "@/interfaces/PointInterfaces";
let isActive = ref(false);
let alertType = ref("danger");
let alertTitle = ref("");
let alertMessage = ref("");
//Props
const props = defineProps({
  isDismissable: {
    type: Boolean,
    default: false,
  },
});
const displayAlert = (alert_type: string, message: IAlertMessage) => {
  alertType.value = alert_type;
  alertTitle.value = message.title;
  alertMessage.value = message.text;
  setAlertVisibility(true);
};
const setAlertVisibility = (is_visible: boolean) => {
  isActive.value = is_visible;
  if (!props.isDismissable) {
    setTimeout(() => {
      isActive.value = false;
    }, 5000);
  }
};
defineExpose({ displayAlert });
</script>
<style>
.slide-up-enter-active,
.slide-up-leave-active {
  transition: all 0.25s ease-out;
}

.slide-up-enter-from {
  opacity: 0;
  transform: translateY(30px);
}

.slide-up-leave-to {
  opacity: 0;
  transform: translateY(-30px);
}
</style>
